import React from 'react';
import { Button } from 'react-bootstrap';
import './FloatingButton.scss';

function FloatingButton() {
  return (
    <Button
      className="floating-btn"
      href="https://wa.me/447477013710"
      target="_blank"
      rel="noopener noreferrer"
      variant="success"
      aria-label="Chat on WhatsApp"
    >
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
        alt="Chat on WhatsApp"
      />
    </Button>
  );
};

export default FloatingButton;
